import { Button } from '@vmware-react/clarity/dist/button';
import classNames from 'classnames';
import React from 'react';
import { renderField } from './renderer';
import { DField, DFormArrayField, DFormArrayValue } from './types';

interface Props {
  field: DFormArrayField;
  value: DFormArrayValue;
  error?: string;
  touched?: boolean;
  hidden?: boolean;
  onAddItem: () => void;
  onRemoveItem: (index: number) => void;
}

export default (props: Props) => {
  const {
    field,
    error,
    touched,
    hidden,
    value,
    onAddItem,
    onRemoveItem
  } = props;
  const hasError = typeof error === 'string' && error.length > 0;

  return (
    <div className="clr-form-control crc-form-array" hidden={hidden}>
      <div className="crc-form-array-header">
        <label className="clr-control-label">{field.label}</label>
        <div className="crc-form-array-item-add">
          <Button size="sm" icon={true} family="link" onClick={onAddItem}>
            <clr-icon shape="plus-circle" size="20" />
          </Button>
        </div>
      </div>
      <div className="clr-control-container">
        {value.map((v, i) => {
          const onClickDelete = () => onRemoveItem(i);
          const updateFieldName = (f: DField) => ({
            ...f,
            name: `${field.name}.${i}.${f.name}`
          });

          return (
            <div key={`${field.name}.${i}`} className="crc-form-array-item">
              <div className="crc-form-array-item-controls">
                {field.data.fields.map(updateFieldName).map(renderField())}
              </div>

              <div className="crc-form-array-item-action">
                <div className="crc-form-array-item-corner-top" />
                <div
                  className="crc-form-array-item-del"
                  onMouseOver={onMouseOverDelItem}
                  onMouseOut={onMouseOutDelItem}>
                  <Button size="sm" onClick={onClickDelete}>
                    <clr-icon shape="trash" />
                  </Button>
                </div>
                <div className="crc-form-array-item-corner-bottom" />
              </div>
            </div>
          );
        })}
      </div>
      <div
        className={classNames('clr-subtext-wrapper', {
          'clr-error': hasError && touched
        })}>
        <span className="clr-subtext">
          {hasError && touched ? error : field.helperText}
        </span>
      </div>
    </div>
  );
};

const onMouseOverDelItem = (event: React.MouseEvent<HTMLDivElement>) => {
  (event.target as HTMLDivElement).parentElement!.parentElement!.classList.add(
    'active'
  );
};

const onMouseOutDelItem = (event: React.MouseEvent<HTMLDivElement>) => {
  (event.target as HTMLDivElement).parentElement!.parentElement!.classList.remove(
    'active'
  );
};
